
export   const products = [
    { 
      id: 66, 
      name: 'LED Flood Light 50W', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/FloodLight/Fl50front.jpg', '../Assets/FloodLight/Fl50angle.jpg', '../Assets/FloodLight/Fl50back.jpg'],
      tableimgUrl: ['../Assets/Table/Floodlighttable.JPG'] 
    },
    { 
      id: 67, 
      name: 'LED Flood Light 100W', 
      description: 'Consistent CCT Output<br>• No flickering, UV/IR & Mercury free<br>• Lumen Maintenance after 2000 Hours > 90%<br>• Good CRI Level<br>• Tested 2000 Hours<br>• Life Time 30,000 hrs.', 
      imageUrls: ['../Assets/FloodLight/Fl100front.jpg', '../Assets/FloodLight/Fl100angle.jpg', '../Assets/FloodLight/Fl100back.jpg'],
      tableimgUrl: ['../Assets/Table/Floodlighttable.JPG'] 
    },
  
  
  ];
    
    export default {
        products,
    }
  